import {
  BondScreenerViewNameModal,
} from '@/creditflowresearch/ui/common/components/molecules/BondScreenerViewNameModal';

interface IBondScreenerCreateViewModalProps {
  isVisible: boolean,
  existingNames: string[],
  onCreate: (name: string) => void,
  onCancel: () => void,
}

const BondScreenerCreateViewModal = ({
  isVisible,
  existingNames,
  onCreate,
  onCancel,
}: IBondScreenerCreateViewModalProps) => (
  <BondScreenerViewNameModal
    isVisible={ isVisible }
    title="Create View"
    submitLabel="Create View"
    dataTest="bondScreenerCreateViewModal"
    existingNames={ existingNames }
    onSubmit={ onCreate }
    onCancel={ onCancel }
  />
);

export default BondScreenerCreateViewModal;
